import { configureStore } from "@reduxjs/toolkit";
import snackbar from './snackBar/reducers'
import trigger from "./trigger";
import pdfData from "./printPdf/pdfData"
import thermalData from "./printPdf/thermalData";
import menuLoad from "./menuLoad";

export default configureStore({
    reducer:{
        snackbar: snackbar,
        trigger : trigger,
        getData : pdfData,
        getThermalData : thermalData,
        menuLoad:menuLoad
    }
})